import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { QuoteDetailPageInitialData } from "./quoteDetailPageInitialData";

const QUOTE_DETAIL_PAGE_ID = "my-account/quotes/detail";
const ACCOUNT_SWITCH_QUERY_ALIASES = {
  account: "targetAccount",
  salesOrg: "targetSalesOrg",
} as const;

export interface QuoteDetailPageSearch {
  id?: string;
  account?: string;
  salesOrg?: string;
}

function buildPath(search: QuoteDetailPageSearch): string {
  const params = new URLSearchParams();
  if (search.id !== undefined) {
    params.set("id", search.id);
  }
  if (search.account !== undefined) {
    params.set("account", search.account);
  }
  if (search.salesOrg !== undefined) {
    params.set("salesOrg", search.salesOrg);
  }
  const query = params.toString();
  return `${QUOTE_DETAIL_PAGE_ID}${query ? `?${query}` : ""}`;
}

export const quoteDetailPageQueryOptions = (search: QuoteDetailPageSearch = {}) =>
  queryOptions({
    queryKey: pageDataKeys.pageWithInputs(QUOTE_DETAIL_PAGE_ID, search),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<QuoteDetailPageInitialData>>(`/page-data/${buildPath(search)}`, {
        queryParamAliases: ACCOUNT_SWITCH_QUERY_ALIASES,
      }),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
